import { render, staticRenderFns } from "./BlacklistRuleModify.vue?vue&type=template&id=74ad52c5"
import script from "@/scripts/modal/systemManager/blacklistRule/blacklistRuleModify.js?vue&type=script&lang=js&external"
export * from "@/scripts/modal/systemManager/blacklistRule/blacklistRuleModify.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports